document.addEventListener('turbo:load', event => {
    if (typeof gtag === 'function') {
        gtag('config', 'UA-53059619-6', {
            'page_location': event.detail.url,
            'anonymize_ip': true
        });
    }
});
